import { all } from 'redux-saga/effects';
import watchCategories from './categories';
import { watchList } from './list';

export function* watchLabs() {
  yield all([watchList(), watchCategories()]);
}
